import type { BottleType } from "../schema";
import { INK, centred, doc, imageSlot, labelWidth } from "./kit";
import type { LabelTemplate } from "./types";

// Photo label: a full-bleed photo slot across the top (the one element that
// may touch the label edge) and a typeset band beneath. The slot spans the
// label width, so each bottle has its own layout.
export const photoBand: LabelTemplate = {
  key: "photo-band",
  name: "Photo label",
  occasion: "celebration",
  style: "Photo label",
  description: "Your photo edge to edge above a typeset band.",
  hasImageSlot: true,
  slot: "photo",
  build(bottle: BottleType) {
    const W = labelWidth(bottle);
    return doc(bottle, INK["warm-white"], [
      imageSlot({ x: 0, y: 0, width: W, height: 66 }, "Add your photo"),
      centred(bottle, { text: "Happy 50th, Michael", font: "playfair", size: 4, color: INK.charcoal, baseline: 79, tracking: 0.02 }),
      centred(bottle, { text: "26 September 2026", font: "montserrat", size: 2, color: INK.bronze, baseline: 87, tracking: 0.15 }),
    ]);
  },
};
